module.exports = __webpack_public_path__ + "static/media/idea.b5eac40a.svg";